import { useState } from "react";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import cn from "classnames";
import { BsArrowRightCircleFill } from "react-icons/bs";

export const FeatureSplitWithImage = ({
  className,
  title,
  heading,
  content,
  items,
  reverse,
  background,
  image,
  accordion,
}) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const getVariantClass = (variant) => {
    switch (variant) {
      case "yellowWhite":
        return styles.yellowBox;
      case "blueBox":
        return styles.blueBox; 
      default:
        return styles.blackBox;
    }
  };

  return (
    <section
      className={cn(
        styles.FeatureSplitWithImage,
        className,
        reverse && styles.reverse,
        styles[background]
      )}
    >
      <Container className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            {title && <h2 data-sourceflow-prop="title" className={`${heading}`}>{title}</h2>}
            {content && (
              <div
                data-sourceflow-prop="content"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
            <figure className="m-0 h-100">
              <img
                src={
                  image?.url || "/site-assets/placeholders/img-placeholder.jpg"
                }
                alt={image?.alt}
                className={cn(
                  "card-img bg-white h-100 mt-4",
                  styles.roundedImage
                )}
              />
            </figure>
          </div>

          <div className={styles.itemList}>
            {items?.map((item, i) => {
              const isOpen = openIndex === i;
              const variantClass = getVariantClass(item.variant);

              return accordion ? (
                // Accordion mode
                <div
                  key={i}
                  className={cn(styles.items, variantClass, isOpen && styles.open)}
                >
                  <button
                    type="button"
                    onClick={() => handleToggle(i)}
                    className={styles.accordionHeader}
                  >
                    {item?.icon?.url && (
                      <img src={item.icon.url} alt="" className="icon-item" />
                    )}
                    <h4>{item.title}</h4>
                    <BsArrowRightCircleFill
                      className={cn(styles.icon, { [styles.rotated]: isOpen })}
                    />
                  </button>
                  {isOpen && (
                    <div
                      className={styles.accordionContent}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  )}
                </div>
              ) : (
                // Default link card mode
                <a
                  href={item?.url || "#"}
                  className={cn(styles.item, variantClass)}
                  key={i}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item?.icon?.url && (
                    <img src={item.icon.url} alt="" className="icon-item" />
                  )}
                  <div className={styles.texts}>
                    <h4>{item.title}</h4>
                    <div
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                  <BsArrowRightCircleFill />
                </a>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};
